import { render, staticRenderFns } from "./membership-card.vue?vue&type=template&id=488f1bf8"
import script from "./membership-card.vue?vue&type=script&lang=js"
export * from "./membership-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports